Monet.Format = Monet.Format || {};
Monet.Format.IMAGE_UPLOAD = (function () {

    function IMAGE_UPLOAD(value){

        Monet.Format.Base.apply(this, arguments);

        this.value = value;

        this.toGrid = function () {
            this.value = this.value ? '<div class="gridCheckboxTrue"></div>' : '<div class="gridCheckboxFalse"></div>';
            return this;
        };

    }

    return IMAGE_UPLOAD;

}());